import { createEntity } from "actions/entities";
import { updateUI } from "actions/ui";
import DossierFollowUp from "components/dossiers/dossierFollowUp/DossierFollowUp";
import NewEntityModal from "components/entities/NewEntityModal";
import { findDraftForDossier } from "drafts";
import React from 'react'
import { connect } from 'react-redux'
import { getCurrentEmployment } from "selectors/employments";
import { findEntity } from "selectors/entities";
import DossierItemForm from "./DossierItemForm";

const restoredNoteModalKey = (dossierId) => `RestoredNoteNew-${dossierId}`
class DossierFollowUpContainer extends React.Component {
  componentDidMount() {
    this.props.restoreNewDraft()
  }

  render() {
    const { dossierId } = this.props
    return [
      <NewEntityModal key="newDraftModal" entityName="dossierItem" form={DossierItemForm}
                      defaultKey={restoredNoteModalKey(dossierId)} trigger={() => null}
                      header={this.props.newEntityHeader}/>,
      <DossierFollowUp key="followUp" dossierId={dossierId}/>
    ]
  }
}

const mapStateToProps = (state, ownProps) => {

  let dossier = findEntity(state, 'dossier', ownProps.dossierId)
  let patient = findEntity(state, 'contact', dossier && dossier.patientId)
  const patientName = patient? `${patient?.firstName} ${patient?.lastName}:` : ''
  const newEntityHeader = `${patientName} ${I18n.t('components.dossier_item.note')}`

  return {
    newEntityHeader: newEntityHeader
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  restoreNewDraft: () => dispatch(async (dispatch, getState) => {
    const employment = getCurrentEmployment(getState())
    if (!employment?.draftEncryptionKey) return

    const draft = await findDraftForDossier(ownProps.dossierId, employment)
    if (!draft || !draft.data) return

    const id = dispatch(createEntity('dossierItem', draft.data))
    const key = restoredNoteModalKey(ownProps.dossierId)
    dispatch(updateUI(key, 'modalEntityId', id))
    dispatch(updateUI(key, 'modalOpen', true))
  })
})

export default connect(mapStateToProps, mapDispatchToProps)(DossierFollowUpContainer)
